import {QuestID} from './models/QuestID.enum';
import {QuestStatus} from "./models/QuestStatus.enum";

import {ScreenButton} from "./utils/ScreenButton";
import {CustomView} from "./utils/CustomView";
import {QueueTweenAnimation} from './utils/WindowAnimation';

const {
  ElianaPictures,
  GamePictures,
  RandomChick,
  RubinaPictures,
  SamanthaPictures,
  SofiaPictures
} = require("./services/game-pictures.service");
const {GameUtils} = require("./services/game-utils.service");
const {EventStateService} = require("./services/event-state.service");
import {NotificationService} from "./services/notification.service";
import {EquipmentService} from "./services/equipment.service";
import {QuestService} from "./services/quest.service";
import {CreditsService} from "./services/credits.service";
import {EventLogService} from "./services/event-log.service";
import {CasinoService} from "./services/casino.service";

const {AnastasiaEvents} = require("./events/anastasia.events");
const {VickyEvents} = require("./events/vicky.events");
const {BartEvents} = require("./events/bart.events");
const {AnnieEvents} = require("./events/annie.events");
const {DaveEvents} = require("./events/dave.events");
const {DianaEvents} = require("./events/diana.events");
const {JessicaEvents} = require("./events/jessica.events");
const {LisaEvents} = require("./events/lisa.events");
const {PaulaEvents} = require("./events/paula.events");
const {SamanthaEvents} = require("./events/samantha.events");
const {SofiaEvents} = require("./events/sofia.events");
const {TinaEvents} = require("./events/tina.events");
const {DreamEvents} = require("./events/dream.events");
const {GameEvents} = require("./events/game.events");
const {ElenEvents} = require("./events/elen.events");
const {MegEvents} = require("./events/meg.events");
const {ElianaEvents} = require("./events/eliana.events");
const {TiaTameraEvents} = require("./events/tiaTamera.events")

import {MainController} from "./controllers/main.controller";
import {TimeController} from "./controllers/time.controller";

import {Spriteset_InventoryUI} from "./sprites/InventoryUI.sprite";
import {InteractionsService} from "./services/interactions.service";
import {SeleneEvents} from "./events/selene.events";

// Register globals
window.YS = {};
window.YsUtils = {};
window.YsEvents = {};
window.YsServices = {};
window.YsControllers = {};
YS.Sprites = {};
YS.Utils = {};
YS.Services = {};
YS.Models = {};

// Models
YS.Models.QuestID = QuestID;
YS.Models.QuestStatus = QuestStatus;

// Utils
YsUtils.ScreenButton = ScreenButton;
YS.Utils.CustomView = CustomView;
YS.Utils.QueueTweenAnimation = QueueTweenAnimation;

// Services
window.EventStateService = EventStateService;
window.ElianaPictures = ElianaPictures;
window.GamePictures = GamePictures;
window.RandomChick = RandomChick;
window.RubinaPictures = RubinaPictures;
window.SamanthaPictures = SamanthaPictures;
window.SofiaPictures = SofiaPictures;
window.GameUtils = GameUtils;
YsServices.notificationService = new NotificationService();
YsServices.equipmentService = new EquipmentService();
YsServices.questService = new QuestService();
YsServices.creditsService = new CreditsService();
YS.Services.eventlogService = new EventLogService();
YS.Services.questService = YsServices.questService;
YS.Services.casinoService = new CasinoService();
YS.Services.interactionsService = new InteractionsService();

// Events
window.AnastasiaEvents = AnastasiaEvents;
window.VickyEvents = VickyEvents;
window.BartEvents = BartEvents;
window.AnnieEvents = AnnieEvents;
window.DaveEvents = DaveEvents;
window.DianaEvents = DianaEvents;
window.JessicaEvents = JessicaEvents;
window.LisaEvents = LisaEvents;
window.PaulaEvents = PaulaEvents;
window.SamanthaEvents = SamanthaEvents;
window.SofiaEvents = SofiaEvents;
window.TinaEvents = TinaEvents;
window.GameEvents = GameEvents;
window.ElenEvents = ElenEvents;
window.MegEvents = MegEvents;
window.ElianaEvents = ElianaEvents;
window.TiaTameraEvents = TiaTameraEvents;
window.SeleneEvents = SeleneEvents;
YsEvents.DreamEvents = DreamEvents;

// Controllers
YsControllers.MainController = new MainController();
YsControllers.TimeController = TimeController;

// Sprites
YS.Sprites.Spriteset_InventoryUI = Spriteset_InventoryUI;
